<div class="grid-stack-item-content" [ngClass]="{ isDraggable: draggable }">
  <div
    class="widget-heading"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
  >
    <div class="title">
      {{ title }}
    </div>
    <div class="options">
      <button
        class="filter-btn"
        *ngFor="let contentType of contentTypes"
        mat-icon-button
        [disabled]="contentType.type === selectedContentType"
        [matTooltip]="contentType.name"
        matTooltipPosition="above"
      >
        <svg-icon
          src="{{ contentType.icon }}"
          [svgStyle]="contentType.svgStyle"
          [ngClass]="{ selected: contentType.type === selectedContentType }"
        >
        </svg-icon>
      </button>
      <div class="divider"></div>
      <button
        *ngFor="let category of categories"
        mat-icon-button
        class="filter-btn"
        (click)="toggleCategory(category)"
        [matTooltip]="category.name"
        matTooltipPosition="above"
      >
        <fa-icon
          [icon]="category.iconArr"
          [ngClass]="{ selected: category.selected }"
        >
        </fa-icon>
      </button>
      <button mat-icon-button>
        <svg-icon
          src="assets/svg/trashcan.svg"
          (click)="delete()"
          [svgStyle]="{
            'width.px': '17',
            'height.px': '17'
          }"
          svgClass="grey"
          viewBox="auto"
        ></svg-icon>
      </button>
    </div>
  </div>
  <div class="widget-content" lhpeElementLoader #elementLoader="elementloader">
    <div class="row">
      <button
        mat-icon-button
        (click)="moveLeft()"
        [disabled]="leftScrollDisabled"
      >
        <svg-icon src="assets/svg/left-arrow.svg"> </svg-icon>
      </button>
      <div id="signals" class="signals">
        <div *ngFor="let signal of filteredSignals" class="signal">
          <div class="last-sent">{{ signal.sent_on_text }}</div>
          <div class="signal-box">
            <div
              class="heading"
              [ngStyle]="{ 'background-color': signal.category_color }"
            >
              <div class="text">
                {{ signal.name }}
              </div>
            </div>

            <div class="info">
              <div
                class="signal-icon"
                [ngStyle]="{ color: signal.category_color }"
              >
                <span><fa-icon [icon]="signal.iconArr"></fa-icon></span>
              </div>
              <div class="signal-text">
                <div class="text">
                  {{ signal.push_notification_text }}
                </div>
              </div>
              <div class="sent">{{ signal.sent }} sent</div>
            </div>
          </div>

          <div class="signal-type">
            <svg-icon
              *ngIf="signal.content_type === 'push'"
              src="assets/svg/push-content.svg"
              [svgStyle]="{
                'width.px': '16.25',
                'height.px': '19.899'
              }"
              svgClass="white"
            >
            </svg-icon>
          </div>
        </div>
      </div>
      <button
        class="right-arrow"
        mat-icon-button
        (click)="moveRight()"
        [disabled]="rightScrollDisabled"
      >
        <svg-icon src="assets/svg/right-arrow.svg"> </svg-icon>
      </button>
    </div>
  </div>
</div>
